__turbopack_context__.v({
  "foodScoreElement": "FoodListElement-module__OXbrmG__foodScoreElement",
  "foodTextContent": "FoodListElement-module__OXbrmG__foodTextContent",
  "root": "FoodListElement-module__OXbrmG__root",
});
